import React from 'react';
import { useTranslation } from 'react-i18next';

import './MultiSelectDownload.scss';

import { SelectAndDownload } from '../../../results-helpers/SamplesListShared';
interface IMultiSelectDownload {
  isSelected: boolean;
  callback: Function;
  isItems?: boolean;
  isDownloadable?: Function;
  cancelDownload: Function;
}

export const MultiSelectDownload: React.FC<IMultiSelectDownload> = ({
  isSelected,
  callback,
  isItems = false,
  isDownloadable = () => {},
  cancelDownload,
}) => {
  const { t } = useTranslation();
  return (
    <div id='table-multi-select'>
      {!isSelected ? (
        <SelectAndDownload onClick={() => callback()} />
      ) : (
        <>
          <span className='text-type-1 mr-2'>
            {t('sampleList_results_selectToDownload')}
          </span>
          <button
            key={Math.random()} // required for checkbox refresh to work
            className={`btn btn-primary btn-sm mr-2 ${
              !isItems ? 'disabled' : ''
            }`}
            disabled={!isItems}
            onClick={() => isDownloadable()}
          >
            <span className='text-uppercase'>
              {t('sampleList_results_downloadSelectedResults')}
            </span>
          </button>
          <button
            className='btn btn-light btn-sm'
            onClick={() => cancelDownload()}
          >
            <span className='text-uppercase'>{t('common_cancel')}</span>
          </button>
        </>
      )}
    </div>
  );
};
